import * as yup from "yup";
import { enums } from "../constants/enum";
 const reportSchema = yup.object({
  range: yup.string().oneOf(Object.values(enums.REPORTING_PERIODS)).required(),
  from: yup.date().when("range", {
    is: enums.REPORTING_PERIODS.CUSTOM,
    then: (schema) => schema.required(),
    otherwise: (schema) => schema.nullable().notRequired(),
  }),
  to: yup.date().when("range", {
    is: enums.REPORTING_PERIODS.CUSTOM,
    then: (schema) => schema.required(),
    otherwise: (schema) => schema.nullable().notRequired(),
  }),
});

export default reportSchema;
